import {StabilityRuleFormSchema} from '@/modules/drug-catalog/stability-rules/schemas'
import {OralQuantityBasis} from '@cypro/engine/database/schema'
import {AddMedicationProfileSchema} from '@cypro/engine/mutators'
import {Status} from '@cypro/engine/schema'
import * as z from 'zod'

export const MedicationProfileFormSchema = AddMedicationProfileSchema.omit({
  medicineFormId: true,
  oralQuantityBasis: true,
  status: true,
  stabilityRules: true,
}).extend({
  medicineFormId: z.array(z.uuidv7()).nonempty(),
  medicineFormName: z.string().optional(),
  oralQuantityBasis: z.array(OralQuantityBasis),
  status: z.array(Status),
  stabilityRules: z.array(StabilityRuleFormSchema),
  oralSpecificsRequired: z.boolean(),
})
export type MedicationProfileFormSchema = z.infer<typeof MedicationProfileFormSchema>
